import { Flex, Spinner } from '@withjoy/joykit';
import React from 'react';

export const MapLoader = () => {
  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      height="100%"
      width="100%"
      flex={1}
    >
      <Spinner />
    </Flex>
  );
};
